import React from "react";
import { useMediaQuery } from "@chakra-ui/react";
import {
  Box,  
  Flex,
  Heading,
  Text
} from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, A11y } from "swiper";
import enableSwiperClicksFromNav from "../../helpers/enableSwiperClicksFromNav";
import "swiper/css";
import "swiper/css/a11y";
import "./quotes-carousel.scss";
import { CarouselProps } from "../../types/homePageTypes";


const QuotesCarousel = ({ title, isWebProgrammeSlider, sliderItems }: CarouselProps) => {
  const [isLargerThan1200] = useMediaQuery("(min-width: 1200px)");
  const { swiperRef } = enableSwiperClicksFromNav();


  return (
    <Box 
      marginTop="0 !important" 
      marginBottom={{  base: "50px !important", xl: "0 !important" }}
    >
      <Heading as="h2" sx={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: '0',}}>
        { title }
      </Heading>
      {sliderItems.length > 0 &&
        <>
          <Swiper
            className="quotesCarousel"
            onSwiper={( swiperInstance ) => { swiperRef.current = swiperInstance }}
            slidesPerView={ 1 }
            loop={ true }
            effect={ "fade" }
            modules={[ Autoplay, EffectFade, A11y ]}
          >
            {sliderItems.map(( slide, index ) => {
                return (
                  <SwiperSlide key={ index }>
                    <Flex
                      p={{ base: "1px 46px", lg: "1px 97px" }}
                      direction="column"
                      justifyContent="center !important"
                      alignItems="flex-start !important"
                      bgColor="white"
                    >

                      {/* label */}
                      <Box 
                        display="flex"
                        flexDirection="row"
                        gap={{ base: "10px", sm: "15px" }}
                        marginBottom={{ base: "16px", sm: "36px", lg: "37px" }}
                      >
                        {slide.webProgramme.length > 0 &&
                          slide.webProgramme.map(( label, labelIndex ) => {
                            // allow only one tag
                            if (labelIndex > 0) {
                              return null
                            }
                            return (
                              <Text
                                key={ labelIndex }
                                size={{ base: "quotes-tag-mobile", md: "quotes-tag-tablet", lg: "schedule-item-tag" }}
                                color="black !important"
                                borderColor="black !important"
                              >
                                { label.title }
                              </Text>
                            )
                          })
                        }
                      </Box>

                      {/* quote */}  
                      <Text
                        size={{ base: "quotes-carousel-mobile", lg: "quotes-carousel-desktop" }}
                        textAlign={{ base: "left", xl: "center" }} 
                        marginBottom="16px !important"
                        marginTop="0 !important"
                      >
                        { slide.title }
                      </Text>

                      {/* source copy */}
                      <Box alignSelf="flex-end" marginBottom={{ base: "30px", md: "68px" }}>
                        <Text
                          size={{ base: "quotes-carousel-source-mobile", sm: "quotes-carousel-source" }}
                          dangerouslySetInnerHTML={{ __html: slide.description }}
                        >
                        </Text>
                      </Box>
                    </Flex>  
                  </SwiperSlide>
                )
              })
            }
          </Swiper>

          {!isLargerThan1200 &&
            <>
              {/* divider */}
              <Box
                backgroundColor="#000000"
                h={{ base: "5px", sm: "10px" }}
                w="100%"
                marginLeft="10px" 
              ></Box>
            </>
          }
        </>
      }
    </Box>
  );
}

export default QuotesCarousel;